module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e156NaN"
    }
  }), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e993"
    }
  }, [_c('b', [_vm._v("Dedication ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e1043"
    }
  }, [_c('span', {
    staticClass: "dcap4",
    attrs: {
      "id": "d14e90"
    }
  }, [_c('b', [_vm._v("I ")])]), _vm._v("dedicate this book to my brother, Ryan A. Mustachio. He was a huge inspiration to me during this process, always pushing me along to get this done and to never quit on something that you love. Do what makes you happy in life, because in the end that’s all that really counts!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1263"
    }
  }, [_vm._v("I thank my mother Kristin and my father Mike for being so supportive of me in anything that I do. I thank all of my family and friends who have stuck with me for so long! And I thank you, the readers, for giving this book a chance!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e1403"
    }
  }, [_vm._v("Enjoy!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77d7359e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cian_9781937084424_epub_c5_r1.vue
// module id = 63
// module chunks = 0